import React from "react";
import "./ARFlag.scss";

const ARFlag = ({country, className, flagClassName, useSVG}) => (
  <div className={`ARFlag flags-container ${className}`}>
    <div className={`${useSVG ? `flag-svg ${country}-svg` : `flag ${country}`} ${flagClassName}`}/>
  </div>
);

ARFlag.defaultProps = {
  className: "",
  flagClassName: "",
  useSVG: false
};

export default ARFlag;